import { getWindow } from '@stitch-fix/mode-react';

/**
 * Starts the Mock Service Worker in the browser.
 *
 * `worker.start()` resolves once this document has activated mocking. Requests
 * sent before that go to the network, so `_app` holds rendering until the
 * promise settles. It never rejects: if the worker cannot start the app still
 * renders, just without mocks.
 */
const initMocks = (): Promise<void> => {
  const win = getWindow();

  if (!win) return Promise.resolve();

  // require is synchronous, which allows MSW to be initialized before the app renders,
  // see: https://github.com/mswjs/msw/discussions/1236
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const { worker } = require('./browser');

  return worker.start().then(
    () => undefined,
    (error: unknown) => {
      // eslint-disable-next-line no-console
      console.error('Mock Service Worker failed to start', error);
    },
  );
};

export const mocksReady = initMocks();
